import { Injectable } from '@angular/core';
import { State, Action, Selector, StateContext } from '@ngxs/store';
import {
  WaybillFailedTransactionMessageInitialState,
  WaybillFailedTransactionMessageLoad,
} from './sc4-failed-transaction-message.actions';
import { catchError, map, take } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../../common/services/notification/notification.service';
import { Sc4FailedTransactionMessageService } from './sc4-failed-transaction-message.service';
import { Error, CustomHttpErrorResponse } from '../../../../../../common/constants/error';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface Sc4FailedTransactionMessageStateModel {
  sc4FailedTransactionMessage: string;
  loaded: boolean;
}

const initialState: Sc4FailedTransactionMessageStateModel = {
  sc4FailedTransactionMessage: null,
  loaded: false,
};

@State<Sc4FailedTransactionMessageStateModel>({
  name: 'sc4FailedTransactionMessage',
  defaults: initialState,
})
@Injectable()
export class Sc4FailedTransactionMessageState {
  constructor(
    private sc4FailedTransactionMessageService: Sc4FailedTransactionMessageService,
    private notificationService: NotificationService,
  ) {}

  @Selector()
  static getState(state: Sc4FailedTransactionMessageStateModel): Sc4FailedTransactionMessageStateModel {
    return state;
  }
  @Selector()
  static getWaybillFailedTransactionMessage(state: Sc4FailedTransactionMessageStateModel): string {
    return state.sc4FailedTransactionMessage;
  }
  @Selector()
  static getLoaded(state: Sc4FailedTransactionMessageStateModel): boolean {
    return state.loaded;
  }

  @Action(WaybillFailedTransactionMessageLoad)
  getWaybillFailedTransactionMessage(
    ctx: StateContext<Sc4FailedTransactionMessageStateModel>,
    { payload }: WaybillFailedTransactionMessageLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.sc4FailedTransactionMessageService.getWaybillFailedTransactionMessage(payload).pipe(
      take(1),
      map((sc4FailedTransactionMessage: string) => {
        ctx.patchState({ sc4FailedTransactionMessage, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(WaybillFailedTransactionMessageInitialState)
  setInitialState(ctx: StateContext<Sc4FailedTransactionMessageStateModel>): void {
    ctx.setState(initialState);
  }
}
